module.exports = __webpack_public_path__ + "img/tradition.0d5848f.webp";